import { get, send } from "./api.js";

/**
 * Lessons the signed-in tutor has taken off their Teaching follow-up list.
 *
 * Keyed by the diary row's booking id, which covers both a private booking
 * and a School lesson (`school:<session>:<pupil>`). Dismissing changes no
 * lesson or note; it only stops Home nagging about it.
 */

export async function getFollowUpDismissals(): Promise<{ bookingKeys: string[] }> {
  return get<{ bookingKeys: string[] }>("/admin/follow-up/dismissals");
}

export async function dismissFollowUp(bookingKeys: string[]): Promise<void> {
  await send("POST", "/admin/follow-up/dismissals", { bookingKeys });
}

export async function restoreFollowUp(bookingKeys: string[]): Promise<void> {
  await send("POST", "/admin/follow-up/dismissals/restore", { bookingKeys });
}
